<template>
  <div class="home-view">
    <Topbar />
    
    <div class="container-img" style="padding-top: 90px">
      <div class="container mt-5">
        <div class="row">
          <div class="col-md-3" @click="goTo('resumos')">
            <div class="card">
              <div class="card-header bg-primary text-white">
                Resumos
              </div>
              <div class="card-body">
                <em class="fa fa-clipboard-check fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('cobrancas')">
            <div class="card">
              <div class="card-header bg-info text-white">
                Cobranças
              </div>
              <div class="card-body">
                <em class="fa fa-money-check-alt fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('contratos')">
            <div class="card">
              <div class="card-header bg-success text-white">
                Contratos
              </div>
              <div class="card-body">
                <em class="fa fa-file-contract fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('clientescob')">
            <div class="card">
              <div class="card-header bg-warning text-white">
                Clientes Cobranças
              </div>
              <div class="card-body">
                <em class="fa fa-users fa-4x"></em>
              </div>
            </div>
          </div>
        </div>
        <hr>

        <div class="row">

          <div class="col-md-3" @click="goTo('empresasfat')">
            <div class="card">
              <div class="card-header bg-danger text-white">
                Empresas Faturamento
              </div>
              <div class="card-body">
                <em class="fa fa-building fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('tabcob')">
            <div class="card">
              <div class="card-header bg-secondary text-white">
                Tabela De Cobranças
              </div>
              <div class="card-body">
                <em class="fa fa-table fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('ocorrencias')">
            <div class="card">
              <div class="card-header bg-warning text-white">
                Ocorrências
              </div>
              <div class="card-body">
                <em class="fa fa-tags fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('insumos')">
            <div class="card">
              <div class="card-header bg-primary text-white">
                Insumos
              </div>
              <div class="card-body">
                <em class="fa fa-pallet fa-4x"></em>
              </div>
            </div>
          </div>
        </div>
        <hr>

        <div class="row">
          <div class="col-md-3" @click="goTo('historico')">
            <div class="card">
              <div class="card-header bg-primary text-white">
                Histórico
              </div>
              <div class="card-body">
                <em class="fa fa-clock fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('perfis')">
            <div class="card">
              <div class="card-header bg-success text-white">
                Perfil de Acesso
              </div>
              <div class="card-body">
                <em class="fa fa-id-card fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('usuarios')">
            <div class="card">
              <div class="card-header bg-secondary text-white">
                Usuários
              </div>
              <div class="card-body">
                <em class="fa fa-user fa-4x"></em>
              </div>
            </div>
          </div>

          <div class="col-md-3" @click="goTo('cfg')">
            <div class="card">
              <div class="card-header bg-info text-white">
                Configurações
              </div>
              <div class="card-body">
                <em class="fa fa-cog fa-4x"></em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
    <LogoutModal/>
    <Sidebar/>
  </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import Sidebar from '@/components/Sidebar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
import api from '../services/api'

export default {
  name: 'Home',
  mixins: [
    ViewMixin
  ],
  components: {
    Topbar,
    Sidebar,
    LogoutModal
  },

  async mounted() {
    try {
      await this.validarToken();
    } catch (e) {
      if (e instanceof TokenInvalidoException) {
        this.handleTokenInvalidoException();
      } else if (e instanceof ServerErrorException) {
        alert(e.message);
      } else {
        alert(DEFAULT_ERROR_MESSAGE);
      }      
    }
  },

  methods: {
    async validarToken() {
      this.carregando = true;

      await api.get("/validar-token");

      this.carregando = false;
    },

    goTo(path) {
      this.$router.push(path);
    },
  }
}
</script>

<style scoped lang="scss">    

  .home-view {
    height: 100%;
  }

  .container-img {
    display: flex;
    justify-content: center;
    align-self: center;

    background-color: rgb(233, 233, 233) !important;
    height: 100%;
  }

  .card {
    cursor: pointer;
  }

  .col-md-3 {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .col-md-3:hover {
    box-shadow: 10px 4px 15px rgba(2, 2, 2, 0.2);
    background-color: rgb(196, 193, 193);
    color: #000;
    transition: all 0.3s ease;
  }

  .card-body {
    border: 1px solid #525252;
    border-top: 0px;
  }

  .card-header {
    border: 1px solid #525252;
  }

  img {    
    filter: drop-shadow(0px 0px 100px rgba(0, 0, 0, 0.2));
    max-width: 80%;
  }

  @media only screen and (min-width: 768px) {
    img {    
      max-width: 40%;
    }
  }
</style>
